import { withContext, combineReducers } from 'root/util/reducerContext';
import createReducer from 'root/util/createReducer';

import {
    SET_DATA,
    SET_MENU_VIEW,
    SET_TOAST_CONTENT,
    SET_TOAST_OPEN,
    SET_TOAST_SEVERITY,
    CLOSE_TOAST,
} from 'actions/actions';
import { defaultState } from 'util/constants';

const dataReducer = createReducer(defaultState.data, {
    [SET_DATA]: (state, action) => action.payload,
});

const menuViewReducer = createReducer(defaultState.menuView, {
    [SET_MENU_VIEW]: (state, action) => action.payload,
});

const toastReducer = createReducer(defaultState.toast, {
    [SET_TOAST_CONTENT]: (state, action) => ({
        ...state,
        content: action.payload,
        open: true,
    }),
    [SET_TOAST_OPEN]: (state, action) => ({
        ...state,
        open: action.payload,
    }),
    [CLOSE_TOAST]: () => ({ content: '', open: false }),
    [SET_TOAST_SEVERITY]: (state, action) => ({
        ...state,
        severity: action.payload,
    }),
});

const rootReducer = combineReducers({
    data: dataReducer,
    menuView: menuViewReducer,
    toast: toastReducer,
});

export default withContext(rootReducer);
